import React from 'react';

import { Alert, AlertProps } from '@mantine/core';
import {
  IconCheck,
  IconExclamationCircle,
  IconInfoCircleFilled,
  IconInfoTriangleFilled,
} from '@tabler/icons-react';

import classes from './kiloAlert.module.css';

type VariantStyle = 'default' | 'warning' | 'error' | 'success' | 'containedWarning'; // extendable

interface KiloAlertProps extends AlertProps {
  variantStyle?: VariantStyle;
  title?: string;
}

const variantClassMap = {
  default: {
    root: classes.default,
    icon: classes.defaultIcon,
  },
  warning: {
    root: classes.warning,
    icon: classes.warningIcon,
  },
  error: {
    root: classes.error,
    icon: classes.errorIcon,
  },
  success: {
    root: classes.success,
    icon: classes.successIcon,
  },
  containedWarning: {
    root: classes.containedWarning,
    icon: classes.warningIcon,
  },
};

const iconMap: Record<VariantStyle, React.ReactNode> = {
  default: <IconInfoCircleFilled size={18} />,
  warning: <IconInfoTriangleFilled size={18} />,
  containedWarning: <IconInfoTriangleFilled size={18} />,
  error: <IconExclamationCircle size={18} />,
  success: <IconCheck size={18} />,
};

const KiloAlert = ({
  variantStyle = 'default',
  title,
  variant,
  children,
  ...rest
}: KiloAlertProps): JSX.Element => {
  const variantClasses = variantClassMap[variantStyle];
  const icon = iconMap[variantStyle];

  return (
    <Alert
      icon={icon}
      title={title}
      classNames={{
        ...variantClasses,
        message: classes.message,
        title: classes.title,
      }}
      {...rest}
    >
      {children}
    </Alert>
  );
};

export default KiloAlert;
